import React, { useRef, useState } from "react";

export default function DraggablePreviewPopup({ children }) {
  const popupRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const dragTimeout = useRef(null);

  // Hosszú gombnyomásra induljon a drag
  function handlePointerDown(e) {
    if (e.button !== 0 && e.type !== "touchstart") return;
    const startX = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    const startY = e.type === "touchstart" ? e.touches[0].clientY : e.clientY;
    dragTimeout.current = setTimeout(() => {
      setDragging(true);
      setOffset({
        x: startX - (popupRef.current?.getBoundingClientRect().left || 0),
        y: startY - (popupRef.current?.getBoundingClientRect().top || 0),
      });
    }, 200); // 200ms hosszú nyomás
    window.addEventListener("pointerup", handlePointerUp, { once: true });
    window.addEventListener("touchend", handlePointerUp, { once: true });
  }

  function handlePointerMove(e) {
    if (!dragging) return;
    const clientX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
    const clientY = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;
    setPosition({ x: clientX - offset.x, y: clientY - offset.y });
  }

  function handlePointerUp() {
    clearTimeout(dragTimeout.current);
    setDragging(false);
  }

  // Fix width/height a drag során, ha van explicit méret
  let fixedSize = {};
  if (popupRef.current) {
    const rect = popupRef.current.getBoundingClientRect();
    if (rect.width) fixedSize.width = rect.width;
    if (rect.height) fixedSize.height = rect.height;
  }
  return (
    <div
      className="preview-popup-article"
      ref={popupRef}
      style={{
        cursor: dragging ? "grabbing" : "grab",
        zIndex: 3000,
        position: "fixed",
        top: position.y || 80,
        right: position.x ? undefined : 10,
        left: position.x || undefined,
        ...(dragging ? { pointerEvents: "all" } : {}),
        transition: dragging ? "none" : "top 0.2s, left 0.2s",
        ...fixedSize,
      }}
      onPointerDown={handlePointerDown}
      onTouchStart={handlePointerDown}
      onPointerMove={handlePointerMove}
      onTouchMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onTouchEnd={handlePointerUp}
    >
      {children}
    </div>
  );
}
